import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../service/auth/auth.service';
import { AdminRestService, SocialAnalyticsSummary } from '../service/rest/admin-rest.service';

@Component({
  selector: 'app-admin-social-analytics',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-social-analytics.component.html',
  styleUrl: './admin-users.component.css'
})
export class AdminSocialAnalyticsComponent implements OnInit {
  sessionId = '';
  loading = false;
  error = '';
  fromDate = '';
  toDate = '';
  courseId = '';
  analytics: SocialAnalyticsSummary | null = null;

  constructor(
    private authService: AuthService,
    private adminRest: AdminRestService
  ) {}

  ngOnInit(): void {
    const user = this.authService.getUser();
    this.sessionId = user?.sid || '';
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() - 29);
    this.toDate = today.toISOString().slice(0, 10);
    this.fromDate = start.toISOString().slice(0, 10);
    void this.load();
  }

  async load(): Promise<void> {
    if (!this.sessionId) return;
    this.loading = true;
    this.error = '';
    try {
      const course = this.courseId.trim() ? Number(this.courseId) : undefined;
      this.analytics = await this.adminRest.getAdminSocialAnalytics(this.sessionId, {
        from: this.fromDate,
        to: this.toDate,
        courseId: Number.isFinite(course) ? course : undefined
      });
    } catch (e: any) {
      this.error = e?.message || 'Failed to load analytics';
      this.analytics = null;
    } finally {
      this.loading = false;
    }
  }

  percent(value: number | undefined): string {
    if (value == null) return '0%';
    return `${Math.round(value * 1000) / 10}%`;
  }
}
